module.exports = __webpack_public_path__ + "static/img/faa3b809-a06f-46f3-8c71-827cc7950f6c.d961b70.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/faa3b809-a06f-46f3-8c71-827cc7950f6c.png
// module id = dbob
// module chunks = 1